<div class="organization-credits-page">
    <div class="loading-spinner-container" *ngIf="isLoading">
        <div class="tryb-design-spinner"></div>
    </div>

    <p class="error-message" *ngIf="hasError">
        {{ 'default.errorMessage' | translate }}
    </p>

    <section class="budget-card" *ngIf="budget && !isLoading && !hasError">
        <p class="period">
            {{ budget.periodStartDate | localizedDate: 'shortDate' }} -
            {{ budget.periodEndDate | localizedDate: 'shortDate' }}
            ({{
                'organization.organizationArea.credits.currentBillingPeriod'
                    | translate
            }})
        </p>

        <div class="budget-summary">
            <div class="budget-figure">
                <span class="amount">
                    {{
                        budget.isUnlimited
                            ? '∞'
                            : (budget.total | number: '1.0-0' : currentLanguage)
                    }}
                </span>
                <span class="credits-label">
                    {{
                        'organization.organizationArea.credits.credits'
                            | translate
                    }}
                </span>
                <span class="description">
                    {{
                        'organization.organizationArea.credits.totalAvailable'
                            | translate
                    }}
                </span>
            </div>

            <div class="vertical-divider"></div>

            <div class="budget-figure">
                <span class="amount">
                    {{ budget.used | number: '1.0-0' : currentLanguage }}
                </span>
                <span class="credits-label">
                    {{
                        'organization.organizationArea.credits.credits'
                            | translate
                    }}
                </span>
                <span class="description">
                    {{
                        'organization.organizationArea.credits.used' | translate
                    }}
                </span>
            </div>

            <div class="vertical-divider"></div>

            <div class="budget-figure available-figure">
                <span class="amount">
                    {{
                        budget.isUnlimited
                            ? '∞'
                            : (budget.available
                              | number: '1.0-0' : currentLanguage)
                    }}
                </span>
                <span class="credits-label">
                    {{
                        'organization.organizationArea.credits.credits'
                            | translate
                    }}
                </span>
                <span class="description">
                    {{
                        'organization.organizationArea.credits.stillAvailable'
                            | translate
                    }}
                </span>
            </div>

            <span class="percentage-badge" *ngIf="showPercentage">
                {{
                    'organization.organizationArea.credits.budgetUsed'
                        | translate: { percentage: budget.usedPercentage }
                }}
            </span>
        </div>

        <div class="budget-bar" aria-label="Organization credit budget">
            <div
                class="used-segment"
                [style.width.%]="usedWidth"
                data-testid="used-segment"
            ></div>
            <div
                *ngIf="showAvailableSegment"
                class="available-segment"
                [style.width.%]="availableWidth"
                data-testid="available-segment"
            ></div>
        </div>
    </section>

    <div class="contributor-lists" *ngIf="budget && !isLoading && !hasError">
        <ng-container
            *ngTemplateOutlet="
                contributorCard;
                context: {
                    $implicit: {
                        titleKey:
                            'organization.organizationArea.credits.groups',
                        emptyKey:
                            'organization.organizationArea.credits.emptyGroups',
                        cardTestId: 'groups-card',
                        emptyTestId: 'groups-empty',
                        rowTestId: 'group-row',
                        rows: budget.groups,
                    },
                }
            "
        ></ng-container>
        <ng-container
            *ngTemplateOutlet="
                contributorCard;
                context: {
                    $implicit: {
                        titleKey:
                            'organization.organizationArea.credits.people',
                        emptyKey:
                            'organization.organizationArea.credits.emptyPeople',
                        cardTestId: 'people-card',
                        emptyTestId: 'people-empty',
                        rowTestId: 'person-row',
                        rows: budget.people,
                    },
                }
            "
        ></ng-container>
    </div>

    <ng-template #contributorCard let-list>
        <section class="contributor-card" [attr.data-testid]="list.cardTestId">
            <p class="contributor-title">{{ list.titleKey | translate }}</p>
            <div class="contributor-list">
                <p
                    class="empty-message"
                    *ngIf="list.rows.length === 0"
                    [attr.data-testid]="list.emptyTestId"
                >
                    {{ list.emptyKey | translate }}
                </p>
                <div
                    class="contributor-row"
                    *ngFor="let contributor of list.rows"
                    [attr.data-testid]="list.rowTestId"
                >
                    <span class="rank">{{ contributor.rank }}</span>
                    <span
                        class="name"
                        [attr.title]="
                            contributor.name ??
                            ('organization.organizationArea.credits.unknown'
                                | translate)
                        "
                        >{{
                            contributor.name ??
                                ('organization.organizationArea.credits.unknown'
                                    | translate)
                        }}</span
                    >
                    <span class="credits"
                        >{{
                            contributor.creditsUsed
                                | number: '1.0-0' : currentLanguage
                        }}
                        {{
                            'organization.organizationArea.credits.credits'
                                | translate
                        }}</span
                    >
                </div>
            </div>
        </section>
    </ng-template>
</div>
